import { defineMessages } from 'react-intl';

export default defineMessages({
  mfRecoveryFormPlaceholder: {
    id: 'mf.recoveryform.placeholder',
    defaultMessage: '24-character emergency recovery key',
    description: '',
  },
  errorsInvalidRecoverCode: {
    id: 'mf.recoveryform.errors.invalid_recovery_code',
    defaultMessage: 'You entered an incorrect emergency recovery key.',
  },
  errorsInvalidRecoveryCodeFormat: {
    id: 'mf.recoveryform.errors.invalid_recovery_code_format',
    defaultMessage: 'You entered an invalid emergency recovery key.',
  },
  errorsNoRecoveryCode: {
    id: 'mf.recoveryform.errors.no_recovery_code',
    defaultMessage: 'Please enter your emergency recovery key.',
  },
  errorsInvalidOtpPattern: {
    id: 'mf.recoveryform.errors.invalid_otp_pattern',
    defaultMessage: 'Your emergency recovery key needs to be 24 characters.',
  },
});
